import { useSelector } from 'react-redux';
import { Helpers } from '../core';

/**
 * Returns the redux state for user data
 * @name useUserData
 * @returns {userData}
 */
export default function useUserData() {
    const userData = useSelector(state => state.userData);
    return {
        userData,
    };
}

export const useIsPrivateStore = () => {
    const { userData } = useUserData();
    const { profileData } = userData || {};
    const { personData } = profileData || {};
    const { userTier } = personData || {};
    return getPStoreID(userData) !== undefined && userTier !== 'GS';
};

/**
 * Attempts to pick the private store id from the userData in redux
 * @param {*} userData - user data from redux
 * @returns
 */
export const getPStoreID = userData => {
    const { profileData } = userData || {};
    const { pstoreId, personData } = profileData || {};
    const { pStoreID } = personData || {};
    return pstoreId || pStoreID;
};

export const getUserID = userData => {
    const { profileData } = userData || {};
    const idString = profileData?.personData?.hpProfileId;
    const [id] = (idString || '').split('__');
    return id;
};

export const isCallCenter = userData => {
    const { profileData } = userData || {};
    return profileData && profileData.isccf;
};

export const useUserReceived = () => {
    const userReceived = useSelector(
        state => state && state.userData && (state.userData.updatedFromService || state.userData.userFetchFailed),
    );
    return userReceived;
};

export const useProfileLinks = links => {
    const linkMap = useSelector(state => state && state.userData && state.userData.profileData);
    if (!links) return {};
    const { personData } = linkMap || {};
    const { lastname, firstname } = personData || {};
    return links.reduce(
        (acc, link) => {
            if (linkMap && linkMap[link]) {
                acc[link] = Helpers.decodeHtml(linkMap[link]);
            }
            return acc;
        },
        { lastname, firstname },
    );
};

export const useConsentPreferences = () => {
    return useSelector(state => state?.testFlags?.preferences);
};
